var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPluss1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_1281_181)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1281_181",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1281_181",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1281_181",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADJElEQVR4nO2d3U5TQRSFRy/8g6gXJurLiC+i+ApK1LcwBjDwEAg+gjeiD0AUuSlp0rPWbqDVAN4eMwWTE+2gSDpz6F5fsm+46Mzstdd06LT7hCCEEEIIIYQQQgghxBkZDoe3DXhiwAbJbSMPjaynJA5HawLWrarm41pbUyCdTueaAS8IDFuQqDpHkBwY8HxnZ+dq0eT3+/37Rn4qnRArFcBHM7tXMvm7xZPA4rGbXYRoPdeVz98C2My6HRnwsvii2a4guZAl+fEEcNobLoG1flXNAZgJUwKAmbim0SkoLcL+YDC4NfHJjI6a6Sp4GqYckgtJEcweT3wC8ZyfqPy3wQlWMgcEvo4bvF9VD4IT+nE7Gr8DbE98cAIHCfvNBieY2WzCAQeTHzyx/wVnWKk8SIBjJEBhJEBhJEAIoa7ryxKgwJtwt9u9TnKZwLdRkEvxbznn4NoBBrz+Yw7Aq6xzcC4Ax8zBss7BtQB0PAfXi28gASgB/FVfAzmAEsBf9TWQAygB/FVfAzmAEsBf9TWQAygB/FVfAzmAEsBf9U2DA3q93g2Sb+JFiiVeK3fEr1rGC56zXOpcWAEMWC2dcEsFsJorD//NeQaOd7hG/iieaCbj6F/vmSUAJcA0bkErU70FNb7RsNSmH/WRHJBcdPEmrDmcEwlwjBxApy6UA46RAJQD/Nm/gRxACeCv+hrIAZQA/qqvgRxACeCv+hrIAZQA/qqvgWsHcMxH2fEj5Zxz8C0AuTxGgMWcc3AtQLfbvX5ys3Y0CmBFP1MtQF3Xl2KUGNu1A9qABCiMBCiMBPAqgFqWhbC3t3dzXPIJfC/ZtG8uOAHAw2JN+5LNS4H14AQD3iUcsDb5watqvnj73oLEtvWp9ZvZozyti2P//NQkgI1o0WlrXYy47SQqP2vr4r9WgdNgzrbNo/b18eEFLVi4tSAIfNja2roSchIfWmBkp/TirXx0SN4NJej1endIvm9BEuoiAWwWe4TJL6L1Tlq67xdPCLPFPsln2bed04gngNg/P7ZwJ/kl+R/zBQwer+VzXFs8amY77QghhBBCCCGEEEKIME38BAny2aC95zrGAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluss1);
export default __webpack_public_path__ + "static/media/pluss1.40e6321ceff6dccc2e4569bdf634f880.svg";
export { ForwardRef as ReactComponent };